

<script>
import { urlGenerator } from '../../../Helpers/AxiosHelper';
export default {
	name:"HeroDropdown",
	data() {
		return {
			urlGenerator
		}
	},
	props: {
		loggedIn: {
			required: false,
			type: Boolean
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
